// components/SearchDropdown.tsx
"use client";

import { useState, useRef, useEffect } from "react";
import SearchForm from "./SearchForm";

export default function SearchDropdown() {
  const [open, setOpen] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (open) inputRef.current?.focus();
  }, [open]);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="ask-search-dropdown" ref={wrapperRef}>
      <button
        type="button"
        className="ask-search-dropdown__toggle"
        aria-expanded={open}
        aria-label="Toggle search"
        onClick={() => setOpen((o) => !o)}
      >
        <img src="/assets/images/magnifying.svg" className="search-icon" alt="Search Icon" />
      </button>

      {open && (
        <div className="ask-search-dropdown__panel">
          <p className="ask-search-dropdown__title">Find your course</p>
          <SearchForm className="ask-search-form" inputRef={inputRef} />
        </div>
      )}
    </div>
  );
}